import '@fontsource/mukta/400.css';
import '@fontsource/mukta/500.css';
import '@fontsource/mukta/600.css';
import '@fontsource/mukta/700.css';
import './styles.css';
import { start } from './app.ts';

start().catch((err: unknown) => {
  const el = document.getElementById('screen');
  if (el) el.textContent = `The prototype could not start: ${err instanceof Error ? err.message : String(err)}`;
  throw err;
});

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}
